webpackJsonp([43525766363991],{

/***/ 630:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/mr-bit.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"March 05, 2026","title":"Mr Bit","videoUrl":"https://vimeo.com/1223236646","image":"/img/bit.jpg","credits":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/mr-bit.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-mr-bit-bdec3454f49edc36abe0.js